import React, { ReactNode, useState, useCallback, useEffect, useContext, useMemo } from "react";
import ReactDOM from "react-dom";
import { Button, message, Modal } from "antd";
import {
  folderTypeEnum,
  getJoySpaceDelPermission,
  getJoySpaceReadAllPermission,
  getJoySpaceReadOnlyPermission,
  getJoySpaceReadWritePermission,
  joyspacePermissionType
} from "../../config/permissions.config";
import { configTabs } from "./configTabs";
import "./index.less";
import { FileType, SharesMembers, SharesMembersType } from "../../types";
import { getPageSize } from "../../components/SelectedMembers/config";
import Api, { getUserInfo } from "../../api";
import openAddUserModal from "../AddUserMembers";
import PermissionModal from "../../components/PermissionModal";
import { TabKeyType, getPermissionText } from "./config";
import {
  setPrmission,
  removePrmission,
  getShareIdByPermissionType,
  setBatchPrmission,
  setBatchRemove,
  batchPermission
} from "../../api/permissions";
import events from "../../context/events";
import PermissionSelect from "../../components/PermissionSelect";
import noDataPicture from "@/assets/img/no-content.png";
import { changeEgovUrl, getAIConfigData } from "@/utils/tools";
import { Tabs } from "@jd/focus-joyspace-comps";
import { PermissionEnum } from "../../const";
import { analysisLog } from "@/utils/logAnalytics";
import GlobalContext, { GlobalContextConfig } from "@/context/GlobalContext";
interface IProps {
  id: string;
  type: FileType;
  // title: ReactNode;
  permissionType: joyspacePermissionType;
  permissions: PermissionEnum[];
  title?: string;
  folderType?: folderTypeEnum;
  onOk?: (list: any) => void;
  removeNode?: () => void;
}

const parames: SharesMembers = {
  pageId: "",
  fileType: FileType.Page,
  start: getPageSize().pageIndex || 1,
  length: getPageSize().pageSize || 30,
  memberType: SharesMembersType.ALL
};

const AddMembers = (props: IProps) => {
  const {
    id,
    type,
    folderType,
    permissions,
    permissionType = getJoySpaceReadOnlyPermission(),
    removeNode,
    title = "管理协作者",
    onOk
  } = props;
  const [visibleModal, setVisibleModal] = useState(true);
  const [membersList, setMembersList] = useState([]);
  const [tabs, setTabs] = useState(configTabs());
  const [myPermissionType, setMyPermissionType] = useState(permissionType);
  const [loading, setLoading] = useState(true);
  const [isLoadMore, setLoadMore] = useState(false);
  const [permissionCanSelect, setPermissionCanSelect] = useState(true);
  const [isOnBottomLoading, setOnBottomLoading] = useState(false);
  const { appRuntimeEnv } = useContext<GlobalContextConfig>(GlobalContext);

  const aiConfigName = useMemo(() => {
    const aiUser = getAIConfigData(appRuntimeEnv, "envConfig.aiConfig.aiUser");
    return aiUser?.name;
  }, [appRuntimeEnv]);

  const [user, setUser] = useState<any>();
  // 获取协作人数量
  const getSharesCount = useCallback(
    (pageId = "") => {
      Api.permissions.sharesCount(pageId).then((res: any) => {
        const _tabs = configTabs().map((item: any, index: number) => {
          item.text = `${item.text} (${res[index] || 0})`;
          return item;
        });
        setTabs(_tabs);
      });
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [tabs]
  );
  // 获取协助者真实权限
  const getOwnPermissionType = useCallback(async () => {
    const currentPermissionType = await getShareIdByPermissionType(id);
    // console.log(
    //     currentPermissionType,
    //     'currentPermissionTypecurrentPermissionTypecurrentPermissionTypecurrentPermissionType'
    // );
    setMyPermissionType(currentPermissionType);
    return currentPermissionType;
  }, [id]);
  useEffect(() => {
    getSharesCount(id);
    getOwnPermissionType();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  // 获取协作人列表
  const getUserPermissionList = useCallback(
    (_parames: SharesMembers, userInfo: any = {}) => {
      Api.permissions
        .sharesMembers(_parames)
        .then((res: any) => {
          // console.log(res, "resresresresresresresresres");
          if (res.code !== "200") {
            message.error("操作失败");
            return;
          }
          let result = [];
          if (res?.data) {
            result = res?.data.members.map((item: any) => {
              //   item.avatar = changeEgovUrl(item.avatar);
              console.log(item.avatar, "item.avatar", item.avatarUrl);
              if (item.avatar) {
                item.avatar = changeEgovUrl(item.avatar);
              }
              if (item.avatarUrl) {
                item.avatarUrl = changeEgovUrl(item.avatarUrl);
              }
              console.log(item.avatar, "item.avatar:after", item.avatarUrl);
              item.isLoginUser =
                item.memberType === SharesMembersType.CONTACT && item.memberId === userInfo.id;
              let desc = "";
              if (item.memberType === SharesMembersType.CONTACT) {
                const positionName = item.user.position_name ? item.user.position_name : "暂无填写";
                desc = `${item.user.org_name}-${positionName}`;
              } else if (item.memberType === SharesMembersType.DEPARTMENT) {
                desc = item.fullName;

                item.type = item.nodeType ? TabKeyType.WorkLine : TabKeyType.Department;
              } else {
                desc = `${item.memberCount}人`;
              }
              item.desc = desc;
              item.isChecked = false;
              return item;
            });
          }
          if (_parames.start !== 1) {
            result = [].concat([...membersList], result || []);
          }
          setLoadMore(res?.data?.hasMore || false);
          setMembersList(result);
          console.log(result, "result");
        })
        .finally(() => {
          setLoading(false);
          setOnBottomLoading(false);
        })
        .catch((err) => {
          setLoadMore(false);
          setMembersList([]);
          message.error("未知异常");
        });
    },
    [membersList]
  );
  const getUser = useCallback(async () => {
    const info = await getUserInfo();
    setUser(info);
    getUserPermissionList(parames, info);
  }, [getUserPermissionList]);
  useEffect(() => {
    parames.start = 1;
    parames.pageId = id;
    parames.fileType = type;
    setLoading(true);
    getUser();
    return () => {
      parames.memberType = SharesMembersType.ALL;
      parames.start = 1;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const updata = useCallback(
    ({ pageId, type }) => {
      parames.pageId = pageId;
      parames.fileType = type;
      getSharesCount(parames.pageId);
      parames.start = 1;
      if (!user?.id) {
        getUser();
      }
      getUserPermissionList(parames, user);
    },
    [getSharesCount, getUserPermissionList, getUser, user]
  );
  const openAddMembersModal = useCallback(
    (value: boolean) => {
      openAddUserModal({
        type: type,
        id: id,
        isModalVisible: true,
        title: "添加协作者",
        permissions,
        permissionType,
        folderType,
        isShowManageBtn: false,
        aiConfigName,
        // isOpenFolder,
        onOk: () => {
          updata({
            pageId: id,
            type
          });
        }
      });
    },
    [type, id, aiConfigName]
  );
  const setBatchPermission = useCallback(
    (params: any) => {
      const { permission, shareList = [], shareIdList = [] } = params;
      setOnBottomLoading(true);
      if (isLoadMore) {
        setLoadMore(false);
      }
      if (permission !== joyspacePermissionType.ReadDel) {
        setBatchPrmission(shareList)
          .then((res: any) => {
            const { code, status } = res;
            console.log(res, "res111");
            if (code !== "200") {
              message.error(status);
              events.emit("addMembers:setFailCallback");
              return;
            }
            if (code === "200") {
              events.emit("addMembers:successCallback", permission);
            }
          })
          .finally(() => {
            setOnBottomLoading(false);
          });
      } else if (permission === joyspacePermissionType.ReadDel) {
        setBatchRemove(shareIdList, props.id)
          .then((res) => {
            const { code, status } = res;
            if (code !== "200") {
              message.error(status);
              events.emit("addMembers:setFailCallback");
              return;
            }
            if (code === "200") {
              events.emit("addMembers:successCallback", permission);
            }
          })
          .finally(() => {
            setOnBottomLoading(false);
          });
      }
    },
    [setOnBottomLoading, isLoadMore, events]
  );
  useEffect(() => {
    events.on("joyspace:updata", updata);
    events.on("addmembers:setMembersList", setMembersList);
    events.on("addmembers:setModalAddUserVisible", openAddMembersModal);
    events.on("addmembers:setPermissionCanSelect", setPermissionCanSelect);
    events.on("addmembers:setBatchPermission", setBatchPermission);
    return () => {
      events.off("joyspace:updata", updata);
      events.off("addmembers:setMembersList", setMembersList);
      events.off("addmembers:setModalAddUserVisible", openAddMembersModal);
      events.off("addmembers:setPermissionCanSelect", setPermissionCanSelect);
      events.off("addmembers:setBatchPermission", setBatchPermission);
    };
  }, [updata, setMembersList, openAddMembersModal, setPermissionCanSelect, setBatchPermission]);
  const onButtom = useCallback(() => {
    if (!isLoadMore || isOnBottomLoading) {
      return;
    }
    setOnBottomLoading(true);
    parames.start++;
    getUserPermissionList(parames, user);
  }, [isLoadMore, getUserPermissionList, user, isOnBottomLoading]);
  const onChangeTab = useCallback(
    async (val: any) => {
      parames.start = 1;
      parames.memberType = val;
      setLoadMore(false);
      setLoading(true);
      setMembersList([]);
      // const permissionType = await getOwnPermissionType();
      // if (permissionType === joyspacePermissionType.ReadDel) {
      //     message.error('操作失败');
      //     setLoading(false);
      //     return;
      // }
      getOwnPermissionType();
      getSharesCount(id);
      getUserPermissionList(parames, user);
    },
    [getOwnPermissionType, getSharesCount, id, getUserPermissionList, user]
  );

  const refreshUserList = useCallback(() => {
    getOwnPermissionType();
    getUserPermissionList(parames, user);
  }, [getOwnPermissionType, getUserPermissionList, user]);

  const setCurrentPermissionType = useCallback(
    // eslint-disable-next-line max-params
    async (sharesId = "", item: any, idx = -1, val: any) => {
      let list: any = JSON.parse(JSON.stringify(membersList));
      const currentPermissionType = await getShareIdByPermissionType(id);
      if ((currentPermissionType as any) === joyspacePermissionType.ReadDel) {
        message.error("您不是协作者，无法完成操作");
        setMyPermissionType(currentPermissionType);
        return false;
      }
      // 权限不够
      if (
        currentPermissionType > item.permissionType ||
        currentPermissionType > Math.abs(val) ||
        (!item.isLoginUser &&
          (currentPermissionType as any) === getJoySpaceReadOnlyPermission() &&
          val === joyspacePermissionType.ReadDel)
      ) {
        // eslint-disable-next-line no-debugger
        // debugger;
        setMyPermissionType(currentPermissionType as any);
        message.error("操作失败");
        return false;
      }
      return true;
    },
    [id, membersList]
  );

  // 修改权限上报
  const handlePermissionClick = (item: any, permissionType: joyspacePermissionType) => {
    const pageId = parames.pageId;
    const { memberId, user, isLoginUser } = item;
    let tenant_id = "";
    if (user) {
      tenant_id = user.tenant_id;
    }

    analysisLog(
      "xtbg_jzb_joyspace_home_1676548210761",
      "43",
      pageId,
      memberId,
      tenant_id,
      permissionType.toString(),
      isLoginUser
    );
  };
  const handleMenuClick = useCallback(
    async (val: any, id) => {
      let list: any = JSON.parse(JSON.stringify(membersList));
      const idx = list.findIndex((item: any) => item.id === id);
      // 移除
      if (idx === -1) {
        return;
      }
      const item: any = list[idx];
      const hasPermission = await setCurrentPermissionType(item.id, item, idx, val);
      if (!hasPermission) {
        return;
      }
      if (val === getJoySpaceDelPermission()) {
        let text = item.isLoginUser ? `确定删除自己的个人权限吗？` : "确定删除该协作者吗？";

        // let text = item.isLoginUser
        //     ? `删除后，您将失去对${
        //           type === FileType.Folder ? '文件夹' : '文件'
        //       }的【全部】权限。是否确认此操作？`
        //     : '确定删除该协作者吗？';

        PermissionModal({
          text,
          visibleModal: true,
          onOk: () => {
            removePrmission(id, props.id).then((res) => {
              if (!res) {
                message.error("操作失败");
                return;
              }
              list.splice(idx, 1);
              setMembersList(list);
              if (!item.isLoginUser) {
                parames.start = 1;
                setMembersList([]);
                setLoading(true);
                refreshUserList();
              }
              getSharesCount(parames.pageId);
              events.emit("joyspace:updata_number");
              message.success(`已删除 ${item.name} 协作者`);
              handlePermissionClick(item, val);
              onOk?.(item);
              if (item.isLoginUser) {
                setMyPermissionType(joyspacePermissionType.ReadNothing);
                setVisibleModal(false);
                removeNode?.();
              }
            });
          }
        });
      } else if (item.isLoginUser && val > myPermissionType) {
        const text = `变更后，您将失去文件的【${getPermissionText(
          myPermissionType
        )}】权限。是否确认此操作？`;
        PermissionModal({
          text,
          visibleModal: true,
          onOk: async () => {
            batchPermission([
              {
                permission: val,
                sendMessage: true,
                shareId: item.id,
                resourceId: props.id
              }
            ]).then((res: any) => {
              if (!res) {
                message.error("操作失败");
                return;
              }
              // item.permissionType = val;
              // list.splice(idx, 1, { ...item });
              setMembersList([]);
              setLoading(true);
              parames.start = 1;
              message.success(`已将 ${item.name} 的权限改为${getPermissionText(val, true)}`);
              handlePermissionClick(item, val);
              refreshUserList();
              onOk?.(item);
              // setCurrentPermissionType(item.id, item, idx, val);
            });
          }
        });
      } else {
        batchPermission([
          {
            permission: val,
            sendMessage: true,
            shareId: item.id,
            resourceId: props.id
          }
        ]).then((res) => {
          if (!res) {
            message.error("操作失败");
            return;
          }
          // item.permissionType = val;
          // list.splice(idx, 1, { ...item });
          // setMembersList(list);
          setMembersList([]);
          setLoading(true);
          parames.start = 1;
          message.success(`已将 ${item.name} 的权限改为${getPermissionText(val, true)}`);
          handlePermissionClick(item, val);
          refreshUserList();
          onOk?.(item);
          // setCurrentPermissionType(item.id, item, idx, val);
        });
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [getSharesCount, membersList, myPermissionType, setCurrentPermissionType, refreshUserList, onOk]
  );
  const handleRightNode = useCallback(
    (item: any) => {
      const ownerArr = membersList.filter(
        (item: any) =>
          item.memberType === SharesMembersType.CONTACT &&
          item.permissionType === getJoySpaceReadAllPermission()
      );
      // console.log(ownerArr, 'itemitemitemitemitemitem');
      return (
        <PermissionSelect
          key={item.id}
          onChange={(values: any) => {
            handleMenuClick?.(values, item.id);
          }}
          isOnlyText={
            (!item.isLoginUser && myPermissionType === joyspacePermissionType.ReadOnly) ||
            myPermissionType > item.permissionType ||
            !permissionCanSelect || // 多选框有选中时，禁止改变
            item.inherited // 继承用户不支持修改权限
          }
          permissionType={myPermissionType}
          propsValue={item.permissionType}
          isCheckAll={false}
          isDisableAll={
            item.memberType === SharesMembersType.DEPARTMENT ||
            item.memberType === SharesMembersType.GROUP
          }
          isShowDelMenu={true}
          ownerNum={ownerArr.length}
          isLoginUser={item.isLoginUser}
          type={type}
        />
      );
    },
    [handleMenuClick, myPermissionType, membersList, type, permissionCanSelect]
  );
  const handleModalTitle = useCallback(() => {
    return "管理协作者";
  }, []);
  return (
    <Modal
      className="add-mebers-modal"
      width={520}
      visible={visibleModal}
      destroyOnClose={true}
      title={handleModalTitle()}
      style={{ top: "calc((100% - 532px) / 2)" }}
      onCancel={() => {
        setVisibleModal(false);
        removeNode?.();
        // events.emit("joyspace:updata_number");
      }}
      footer={null}
    >
      <Tabs
        list={membersList}
        defaultActiveKey={tabs[0].type}
        config={tabs}
        onChangeTab={onChangeTab}
        handleMenuClick={handleMenuClick}
        loading={loading}
        isLoadMore={isLoadMore}
        onButtom={onButtom}
        rightRenderDOM={handleRightNode}
        noDataUrl={noDataPicture}
        events={events}
        permissions={permissions as any}
        myPermissionType={myPermissionType}
        type={type}
        id={id}
      />
    </Modal>
  );
};

export default function addMembersModal(props: IProps) {
  const ele = document.createElement("div");
  document.body.appendChild(ele);
  function removeNode() {
    if (ele) {
      ReactDOM.unmountComponentAtNode(ele);
      ele.remove();
    }
  }
  ReactDOM.render(<AddMembers {...{ ...props }} removeNode={removeNode} />, ele);
}
